import { render } from "./ReadMoreCards.vue?vue&type=template&id=5fc51ed2&scoped=true"
import script from "./ReadMoreCards.vue?vue&type=script&lang=js"
export * from "./ReadMoreCards.vue?vue&type=script&lang=js"

import "./ReadMoreCards.vue?vue&type=style&index=0&id=5fc51ed2&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc51ed2"]])

export default __exports__